import { useUiStore } from 'store'

const CollapseIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M7.5 2.5V17.5M6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

export const CollapseSidebar = () => {
	const collapseDesktopSidebar = useUiStore((s) => s.collapseDesktopSidebar)
	const desktopSidebarCollapsed = useUiStore((s) => s.desktopSidebarCollapsed)

	return (
		<button
			className="p-1 rounded-md text-t-desc-gray hover:bg-gray-100 hover:text-t-coupon transition-colors shrink-0"
			onClick={() => {
				collapseDesktopSidebar(!desktopSidebarCollapsed)
			}}
		>
			<div
				className={`transition-transform duration-300 ${
					desktopSidebarCollapsed ? 'rotate-180' : ''
				}`}
			>
				<CollapseIcon />
			</div>
		</button>
	)
}
